import { render, staticRenderFns } from "./OnboardingAthleteLocation.vue?vue&type=template&id=5125f83d&"
import script from "./OnboardingAthleteLocation.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAthleteLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports